import {useRef, useEffect} from "react";
import SwiperCore, {Navigation, Thumbs} from "swiper";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {ThumbsSlider} from "@COMPONENTS/style/slide";

interface Props extends SlideProps {
	onSwiper: (swiper: SwiperCore) => void;
}

const ThumbsSlide = ({onSwiper, children}: Props) => {
	const swiperRef = useRef<SwiperCore>(null);
	useEffect(() => {
		if (swiperRef.current?.slides.length > 0) {
			swiperRef.current.slideToLoop(0, 0, false);
		}
	}, [swiperRef.current?.slides]);
	return (
		<ThumbsSlider
			loop={true}
			spaceBetween={10}
			observer={true}
			observeParents={true}
			slidesPerView={5}
			slidesPerGroup={5}
			onSwiper={onSwiper}
			modules={[Navigation, Thumbs]}
			initialSlide={0}
			onBeforeInit={swiper => {
				swiperRef.current = swiper;
			}}
		>
			{children}
		</ThumbsSlider>
	);
};
export default ThumbsSlide;
